import { Flex, Typography } from '@aloft/toolkit-sui';

import { RoundingAndThresholdExceptions } from './RoundingAndThresholdExceptions.tsx';
import { RoundingSelect } from './RoundingSelect.tsx';
import { ThresholdInput } from './ThresholdInput.tsx';

export const RoundingAndThresholds = () => (
  <Flex flexDirection="column" gap="1rem" width="100%">
    <Flex flexDirection="column" gap=".5rem">
      <Typography variant="h3">Rounding</Typography>
      <Typography variant="h5">Round adjustments:</Typography>
      <RoundingSelect fieldPath="roundingDefault" />
      <RoundingAndThresholdExceptions exceptionType="rounding" />
    </Flex>
    <Flex flexDirection="column" gap=".5rem">
      <Typography variant="h3">Thresholds</Typography>
      <Typography variant="h5">Include adjustment if greater than or equal to:</Typography>
      <ThresholdInput fieldPath="thresholdDefault" />
      <RoundingAndThresholdExceptions exceptionType="threshold" />
    </Flex>
  </Flex>
);
